type OccurrenceStore = {
  __clarityOnePageOccurrence?: Record<string, string>;
  __clarityOnePageOccurrenceNonce?: number;
};

/** One occurrence per document runtime. Full navigation creates a new occurrence; remounts do not. */
export function getClarityOnePageOccurrenceId(page: "home" | "wallet"): string {
  const store = globalThis as typeof globalThis & OccurrenceStore;
  store.__clarityOnePageOccurrence ??= {};
  const existing = store.__clarityOnePageOccurrence[page];
  if (existing) return existing;
  const origin = typeof performance !== "undefined" && Number.isFinite(performance.timeOrigin)
    ? String(performance.timeOrigin)
    : `t${Date.now()}`;
  store.__clarityOnePageOccurrenceNonce = (store.__clarityOnePageOccurrenceNonce ?? 0) + 1;
  const created = `${origin}:${page}:${store.__clarityOnePageOccurrenceNonce}`;
  store.__clarityOnePageOccurrence[page] = created;
  return created;
}

export function resetClarityOnePageOccurrenceForTests(): void {
  const store = globalThis as typeof globalThis & OccurrenceStore;
  delete store.__clarityOnePageOccurrence;
}
